import React from 'react';
import './App.css';
import { useScrollReveal } from './hooks/useScrollReveal';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import VideoMVP from './components/VideoMVP/VideoMVP';
import Conquista from './components/Conquista/Conquista';
import Problema from './components/Problema/Problema';
import Solucao from './components/Solucao/Solucao';
import Planos from './components/Planos/Planos';
import Galeria from './components/Galeria/Galeria';
import Mercado from './components/Mercado/Mercado';
import Validacoes from './components/Validacoes/Validacoes';
import Equipe from './components/Equipe/Equipe';
import Contato from './components/Contato/Contato';
import Footer from './components/Footer/Footer';

function App() {
  useScrollReveal();

  return (
    <div className="App">
      <Header />
      <Hero />
      <VideoMVP />
      <Conquista />
      <Problema />
      <Solucao />
      <Planos />
      <Galeria />
      <Mercado />
      <Validacoes />
      <Equipe />
      <Contato />
      <Footer />
    </div>
  );
}

export default App;
